/*
 * File: backups-list.component.ts                                             *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 16th June 2022 13:17:29                             *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Wednesday, 7th December 2022 12:24:38                        *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { io } from 'socket.io-client';
import { UserService } from 'app/modules/user/services/user.service';
import { Backup } from '../../interfaces/backup.interface';
import { BackupService } from '../../services/backup.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-backups-list',
  templateUrl: './backups-list.component.html',
  styleUrls: ['./backups-list.component.scss'],
})
export class BackupsListComponent implements OnInit, OnDestroy {
  backuplist = new Subscription();
  path: string;
  data: Backup[] = [];
  iduser: string;
  displayedColumns = [
    'name',
    'createdBy',
    'createdAt',
    'size',
    'auto',
    'action',
  ];
  constructor (
    private backupService: BackupService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private trans: TranslateService,
    private messageService: MessageService
    // private popup:PopInfoService
  ) { }

  ngOnInit(): void {
    this.suscriptions();
    
    this.iduser = this.userService.getCurrentUser().id;

    this.backupService.getList();
  }
  
  ngOnDestroy(): void {
    this.backuplist.unsubscribe();
  }

  suscriptions() {
    this.backuplist = this.backupService.backuplist$.subscribe(
      (backups: Backup[]) => {
        
        this.data = backups;
        this.data.forEach((backup) => {
          if(this.userService.user && this.userService.user.name && this.userService.user.surname){
            backup.createdBy = this.userService.user.name.concat(' ', this.userService.user.surname);
          }else{
            
          }
        });

        this.data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      }
    );
  }

  //confirm restore
  confirmRestore(id: string){
    this.confirmationService.confirm({
      message:  this.trans.instant("BACKUPS.CONFIRM_BACKUP"),
      header: this.trans.instant("BACKUPS.RESTORE"),
      icon: "pi pi-exclamation-triangle",
      acceptLabel: this.trans.instant("FORM.YES"),
      closeOnEscape: true,
      key: "confirmRestoreBackup",
      accept:() =>{
        this.restore(id);
      }
    })
  }

  confirmDelete(id:string){
    this.confirmationService.confirm({
      message: this.trans.instant("BACKUPS.CONFIRM_DELETE"),
      header: this.trans.instant("BACKUPS.DELETE"),
      icon: "pi pi-exclamation-triangle",
      acceptLabel: this.trans.instant("FORM.YES"),
      closeOnEscape: true,
      key: "confirmDeleteBackup",
      accept: () => {
        this.delete(id);
      }
    })
  }


  restore(id: string) {
    this.backupService.restore(id).subscribe((data) => {
      // this.popup.addMessage("info","Backup restaurado");
      this.messageService.add({
        severity: 'success',
        summary: this.trans.instant("BACKUPS.RESTORED")
      });
    });
  }

  download(id: string) {
    this.backupService.download(id).subscribe((data) => {
      
      let url = window.URL.createObjectURL(data);
      var downloader = document.createElement('a');
      downloader.href = url;
      downloader.click();

      this.messageService.add({
        severity: 'success',
        summary: this.trans.instant("BACKUPS.DOWNLOADED")
      });
      
    }, (error) => {
      
      this.messageService.add({
        severity: 'error',
        summary: this.trans.instant("BACKUPS.DOWNLOAD_ERROR"),
      });
    });
  }

  create() {
    this.backupService.createBackup(this.iduser)
  }

  delete(id:string){

  }

}
